<template>
  <div class="dead-letter-queues-container">
    <h5>Dead Letter Queues</h5>
    <div class="row" v-if="atLeastOneQueueHasMessages">
      <div class="col-sm-6 col-md-3 col-lg-2" v-for="queue in queues" v-if="queue.messages > 0">
        <queue-count-card :total="queue.messages" :title="queue.name"></queue-count-card>
      </div>
    </div>
    <div class="card" v-else>
      <div class="col-md-12" style="text-align: center;">
        <h6 style="padding: 12px 0 2px 0;">All Dead Letter Queues are empty &#128515;</h6>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import QueueCountCard from 'src/components/UIComponents/Cards/QueueCountCard.vue'
import queues from '@/store/modules/queues'

export default {
  components: {
    QueueCountCard
  },
  computed: {
    ...mapGetters({
      queues: 'queues/deadLetterQueues'
    }),
    atLeastOneQueueHasMessages() {
      return this.queues.length > 0 && this.queues.filter(queue => queue.messages > 0).length > 0
    }
  },
  async beforeMount() {
    await this.$store.dispatch('queues/fetchDeadLetterQueues')
  }
}
</script>

<style scoped>

</style>
